import React, { Dispatch, Fragment, SetStateAction, useEffect, useState } from 'react';
import '../../../../../assets/scss/preview.css';

interface IProps {
  ref?: any;
  formCode?: string;
  itemData?: any;
}

const View = (props: IProps) => {
  return (
    <div>
      <table className={'preview-table preview-bottom-border'}>
        <colgroup>
          <col width={'15%'} />
          <col width={'15%'} />
          <col width={'20%'} />
          <col width={'15%'} />
          <col width={'15%'} />
          <col width={'20%'} />
        </colgroup>
        <tbody>
          <tr>
            <th colSpan={3}>(1st) Evaluation of the exsistence of Underground Facilities</th>
            <th colSpan={3}>
              (2nd) Site Verification
              <br />
              <span style={{ color: 'red' }}>* Site verification must be carried out at site</span>
            </th>
          </tr>
          <tr>
            <td>Discipline</td>
            <td style={{ textAlign: 'center' }}>
              Issuing Authority(IA)
              <br />
              <span style={{ color: 'blue' }}>(SE&A SI)</span>
            </td>
            <td style={{ whiteSpace: 'nowrap', textAlign: 'center' }}>
              Site Verification is Required?
              <br />
              <span style={{ color: 'red' }}>* If required, assign SV for verification</span>
            </td>
            <td style={{ textAlign: 'center' }}>
              Area Authority
              <br />
              <span style={{ color: 'blue' }}>(SE&A SV)</span>
            </td>
            <td style={{ textAlign: 'center' }}>Signature</td>
            <td style={{ textAlign: 'center' }}>Underground Facilities </td>
          </tr>
          <tr>
            <td>Civil</td>
            <td></td>
            <td style={{ textAlign: 'center' }}>YES / NO</td>
            <td></td>
            <td></td>
            <td style={{ textAlign: 'center' }}>YES / NO</td>
          </tr>
          <tr>
            <td>Mechanical</td>
            <td></td>
            <td style={{ textAlign: 'center' }}>YES / NO</td>
            <td></td>
            <td></td>
            <td style={{ textAlign: 'center' }}>YES / NO</td>
          </tr>
          <tr>
            <td>Piping</td>
            <td></td>
            <td style={{ textAlign: 'center' }}>YES / NO</td>
            <td></td>
            <td></td>
            <td style={{ textAlign: 'center' }}>YES / NO</td>
          </tr>
          <tr>
            <td>Electrical</td>
            <td></td>
            <td style={{ textAlign: 'center' }}>YES / NO</td>
            <td></td>
            <td></td>
            <td style={{ textAlign: 'center' }}>YES / NO</td>
          </tr>
          <tr>
            <td>Instrument</td>
            <td></td>
            <td style={{ textAlign: 'center' }}>YES / NO</td>
            <td></td>
            <td></td>
            <td style={{ textAlign: 'center' }}>YES / NO</td>
          </tr>
          <tr>
            <th colSpan={3}>Site Confirmation</th>
            <th colSpan={3}>COMPLETION of Work</th>
          </tr>
          <tr>
            <td style={{ textAlign: 'center' }}>Area HSSE</td>
            <td style={{ textAlign: 'center' }}>Sinature</td>
            <td style={{ whiteSpace: 'nowrap', textAlign: 'center' }}>Supporing Document</td>
            <td style={{ textAlign: 'center' }}>Performing Authority</td>
            <td style={{ textAlign: 'center' }}>Signature</td>
            <td style={{ textAlign: 'center' }}>Verification is done at site?</td>
          </tr>
          <tr>
            <td></td>
            <td></td>
            <td style={{ textAlign: 'center' }}>YES / NO</td>
            <td></td>
            <td></td>
            <td style={{ textAlign: 'center' }}>YES / NO</td>
          </tr>
        </tbody>
      </table>
      <div className={'preview-row preview-bottom-border'}>
        <div
          className={'preview-col preview-label'}
          style={{ backgroundColor: '#FFFFCC', textAlign: 'left' }}
        >
          DESCRIPTION OF UNDERGOUND OR OVERHEAD SERVICES, IF ANY
          <small>(To be filled by CONTRACTOR Section SI or Manager)</small>
        </div>
      </div>
      <div className={'preview-row'}>
        <div className={'preview-col preview-label saf-bg-white'}>Excavator Plate Number: </div>
        <div className={'preview-col preview-value'}></div>
        <div className={'preview-col preview-label saf-bg-white'}>Operator Name: </div>
        <div className={'preview-col preview-value'}></div>
      </div>
    </div>
  );
};

export default View;
